import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import ageImage from "@/assets/exercise-background-photos/welcome-page-2.png";
import { Button } from "@/components/ui/button";
import { FormattedMessage, useIntl } from "react-intl";
import { AuthFormCard } from "@/components/AuthFormCard";
import { AuthHeader } from "@/components/AuthHeader";
import { useAudienceStore } from "@/lib/stores/audienceStore";
import { useAuthStore } from "@/lib/stores/authStore";
import { showToast } from "@/lib/utils/toast";
import { trackEvent } from "@/lib/analytics/googleAnalytics";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { useLocale } from "@/contexts/IntlContext";
export const Route = createFileRoute("/app")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const intl = useIntl();
  const { locale } = useLocale();
  const audience = useAudienceStore((state) => state.audience);
  const { user } = useAuthStore();

  useEffect(() => {
    if (user && user.id) {
      const audienceLabel = user.audience
        ? intl.formatMessage({ id: `register.audience.${user.audience}` })
        : null;

      if (audienceLabel) {
        showToast.info(
          intl.formatMessage(
            { id: "toast.auth.alreadyLoggedInWithAudience" },
            { audience: audienceLabel },
          ),
        );
      } else {
        showToast.info(
          intl.formatMessage({ id: "toast.auth.alreadyLoggedIn" }),
        );
      }

      const targetUrl =
        audience === "CHILD" ? "/children/exercises" : "/adults/exercises";
      navigate({ to: targetUrl });
    }
  }, [user, audience, navigate, intl]);

  const handleContinueWithoutRegistration = () => {
    const targetUrl =
      audience === "CHILD" ? "/children/exercises" : "/adults/exercises";
    trackEvent("continue_without_registration");
    navigate({ to: targetUrl });
  };

  return (
    <div className="flex min-h-screen flex-col relative">
      <AuthHeader
        image={ageImage}
        imageAlt="Get Started"
        title={<FormattedMessage id="app.getStarted" />}
        subtitle={<FormattedMessage id="app.getStarted.description" />}
      />

      <AuthFormCard>
        <div className="flex flex-col space-y-4">
          <button
            type="button"
            onClick={() => navigate({ to: "/audience" })}
            aria-label={intl.formatMessage({ id: "common.back" })}
            className="absolute items-start text-primary top-5 px-1"
          >
            {locale === "ar" ? (
              <FaArrowRight className="h-4 w-4" />
            ) : (
              <FaArrowLeft className="h-4 w-4" />
            )}
          </button>

          <Link to="/auth/register">
            <Button className="w-full h-auto py-3 flex flex-col items-center justify-center leading-tight">
              <span>
                <FormattedMessage id="register.createAccount" />
              </span>
              <span className="text-[11px] font-normal opacity-80 mt-0.5">
                <FormattedMessage
                  id="app.createAccount.noPersonalInfoHint"
                  defaultMessage="No personal info needed"
                />
              </span>
            </Button>
          </Link>

          <Link to="/auth/login">
            <Button className="w-full bg-secondary" variant="secondary">
              <FormattedMessage id="register.signIn" />
            </Button>
          </Link>

          <div className="items-center justify-center flex pt-4">
            <button
              className="text-small text-dark"
              onClick={handleContinueWithoutRegistration}
            >
              <FormattedMessage id="login.continueWithoutRegistration" />
            </button>
          </div>
        </div>
      </AuthFormCard>
    </div>
  );
}
